import { useApiUrl, useQuery } from '@gemini/lux-ds-pms';
import { DevicesApiRoutes } from '../routes/routes';
import { QueryKeyList } from './querykeys';
import { ExamDataDTO } from '@interfaces/interfaces';
import dayjs from 'dayjs';

interface Props {
  organizationCoreId?: string | null;
  locationCoreId?: string | null;
  date?: Date | null;
  enabled?: boolean;
}

export const useGetExamData = ({
  enabled,
  organizationCoreId,
  locationCoreId,
  date,
}: Props) => {
  const dateIsValid = dayjs(date).isValid();
  const baseUrl = useApiUrl(
    DevicesApiRoutes.GetExamData,
    'DEVICE_BFF_API_BASE_URL'
  )
    ?.replace('{organizationCoreId}', String(organizationCoreId))
    ?.replace('{locationCoreId}', String(locationCoreId))
    ?.concat(
      dateIsValid
        ? `?from=${dayjs(date).toISOString()}&to=${dayjs(date)
            .endOf('day')
            .toISOString()}`
        : ''
    );

  return useQuery<ExamDataDTO[]>(baseUrl || '', {
    enabled:
      !!enabled &&
      !!baseUrl &&
      !!organizationCoreId &&
      !!locationCoreId &&
      !!date,
    queryKey: [
      QueryKeyList.ExamDataQueryKey,
      organizationCoreId,
      locationCoreId,
      date,
    ],
  });
};

export default useGetExamData;
